export const commonStyles = {
 pageTitle:
  "text-[54px] font-extrabold leading-tight text-[#FFFFFF]",

  heading:
    "text-[28px] font-bold leading-tight text-[#153E75]",

  paragraph:
    "text-[18px] leading-8 text-gray-600",

  cardTitle:
  "text-[22px] font-bold leading-tight text-[#153E75]",

cardText:
  "text-[18px] leading-8 text-gray-600",
};